export default __webpack_public_path__ + "static/media/Bangers.0e89a227.ttf";